import { SingleClientMain } from '@/components/features/clients/SingleClientMain'

export const SingleClientPage = ({ clientId }: { clientId: string }) => {
  return <SingleClientMain clientId={clientId} />
}
